let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("irD3p")).then(() => parcelRequire('8gPdF'));